export const tariffCodes = {
  FLOW_FORWARD_GBP: 'FLOW_FORWARD_GBP',
  FLOW_FORWARD_EUR: 'FLOW_FORWARD_EUR',
  FLOW_FORWARD_USD: 'FLOW_FORWARD_USD'
};

export const flowForwardTariffCodes = {
  GBP: tariffCodes.FLOW_FORWARD_GBP,
  EUR: tariffCodes.FLOW_FORWARD_EUR,
  USD: tariffCodes.FLOW_FORWARD_USD
};

export const DB_FEE_CODE = 'DB_FEE_100';

export const EVAC_ASSIST_TARIFF_CODE = 'EVAC_TRANSFER';
export const EVAC_ASSIST_PRODUCT_CODE = 'EVAC_TRANSF_ASSIST';

export const marginTariff = {
  MARGIN_TRAIN: 'MARGIN_TRAIN',
  MARGIN_TRAIN_ER: 'MARGIN_TRAIN_ER',
  MARGIN_HOTEL: 'MARGIN_HOTEL',
  MARGIN_HOTEL_CAN_FEE: 'MARGIN_HOTEL_CAN_FEE',
  MARGIN_TRAIN_CAN_FEE: 'MARGIN_TRAIN_CAN_FEE'
};
